module.exports = __webpack_public_path__ + "img/page_msg.64f11eb6.png";